import { Component, effect, inject, input, OnInit, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button'
import { MatTableModule, MatRow, MatTableDataSource } from '@angular/material/table'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';


import { style, state, trigger, transition, animate } from '@angular/animations';
import { FeedstockService } from '../../../services/feedstockservice';
import { StreamsList } from '../../../interfaces/streamsmodel';
import { FilterState, SaveStreamRequest } from '../../../interfaces/generatorsmodel';
import { ViewDocumentsComponent } from '../../loadschedules/view-documents/view-documents.component';
import { AttachDocumentsComponent } from '../../loadschedules/attach-documents/attach-documents.component';
import { ConfirmationDialogComponent, ConfirmationDialogData } from '../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { AddeditStreamComponent } from './addedit-stream/addedit-stream.component';
import { RecurringLoadsComponent } from './recurring-loads/recurring-loads.component';
import { SamplingFrequenciesComponent } from './sampling-frequencies/sampling-frequencies.component';
import { AddeditPickuplocationComponent } from './addedit-pickuplocation/addedit-pickuplocation.component';
import { CommonModule } from '@angular/common';
import { LookUpService } from '../../../services/lookupservice';
import { IdName } from '../../../interfaces/pricematrixmodel';
import { Regions } from '../../../interfaces/regions';
import { NotificationService } from '../../../services/notificationservice';
import { RolePermissionsService } from '../../../services/role-permissions.service';
import { RoleService } from '../../../services/role.service';
import { LoadScheduleControlFlags, ScreenName } from '../../../interfaces/securityPermissions';

@Component({
  selector: 'app-streams',
  standalone: true,
  imports: [MatIcon, MatTableModule, MatRow, MatPaginatorModule, MatSortModule, MatFormFieldModule,
    MatInputModule, MatButtonModule, MatSelectModule, MatDatepickerModule,
     MatMenuModule, MatProgressBarModule, MatProgressSpinnerModule, MatCardModule, CommonModule],
  templateUrl: './streams.component.html',
  styleUrl: './streams.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class StreamsComponent implements OnInit{
  private readonly standardDisplayedColumns: string[] = [ 'actions', 'streamId','streamName', 'foodGroupName', 'foodMatrixName','strength' ,
  'projectedVolume','statusDescription','commissionEligibleDescription','rebateEligibleDescription',
  'siteNumber','haulerName','avG_COD','avG_TVS','avG_TS','avG_TotalCarbon','avG_TotalNitrogen',
  'codRequiredDescription','codEmail','toteDescription','expenseDescription','outboundDescription','disposalMethod','marketName',
  'isCustomerReferenceRequiredDesc'
  ];
  displayedColumns: string[] = [...this.standardDisplayedColumns];
  permissions = inject(RolePermissionsService);
  dataSource = new MatTableDataSource<any>;
  streamsList: StreamsList[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  filterState = input<FilterState | null>(null);
  bdremp: IdName[] = [];
  markets: Regions[] = [];
  refreshTrigger = input<number>(0);
  gridSearchText = input<string | null>(null);
  private _lastMarketId: string = '__UNSET__';
  private _lastGenId: string = '__UNSET__';
  private _lastTrigger: number = -1;
  controlPermissions: LoadScheduleControlFlags = new LoadScheduleControlFlags();

  constructor(private _dialog: MatDialog, private fsService: FeedstockService,
    private lookup: LookUpService, private notificationService: NotificationService,
    private rolesService: RoleService) {
    effect(() => {
      const state = this.filterState();
      const trigger = this.refreshTrigger();

      if (!state || state.tabIndex !== 1) return;

      this.displayedColumns = state.isWalmart
        ? [
            ...this.standardDisplayedColumns.slice(0, this.standardDisplayedColumns.indexOf('haulerName')),
            'noOfBins',
            ...this.standardDisplayedColumns.slice(this.standardDisplayedColumns.indexOf('haulerName'))
          ]
        : [...this.standardDisplayedColumns];

      const marketId = state.market?.toString() || '-1';
      const genId = state.generator?.toString() || '0';
      
      const isForceRefresh = this._lastTrigger !== trigger;
      const hasFilterChanged = this._lastMarketId !== marketId || this._lastGenId !== genId;

      if (!isForceRefresh && !hasFilterChanged) {
        return;
      }

      this._lastMarketId = marketId;
      this._lastGenId = genId;
      this._lastTrigger = trigger;
      
      console.log("fetching streams grid with marketId:", marketId, "genId:", genId, "trigger:", trigger, "tabIndex:", state.tabIndex);
      
      
      if (genId === '0' || genId === 'null') {
        this.dataSource.data = [];
        if (this.dataSource.paginator) this.dataSource.paginator.firstPage();
        return;
      }
      this.getStreams(marketId, genId);
    });

    effect(() => {
      const searchText = this.gridSearchText();
      if (this.dataSource) {
        console.log("applying grid filter with searchText:", searchText);
        this.applyGridFilter(searchText ?? '');
      }
    });
  }
  
  ngOnInit(): void {
    
    let roles = this.rolesService.getRolesAsString();
    this.permissions.getRolePermissionsNew(roles, ScreenName.CustomerInfo, 0).subscribe({
      next: (perms: LoadScheduleControlFlags) => {
        this.controlPermissions = perms;
      }
    })
    this.getBdrEmployees();
  }

  getBdrEmployees() {
    this.lookup.getAllEmployeesLookUp().subscribe({
      next: (data: IdName[]) => {
        this.bdremp = data;
      }
    });
  }
  
  getStreams(marketId: string, generatorId: string){
    this.fsService.getStreamList(marketId, generatorId).subscribe({
      next: (res: StreamsList[]) => {
        console.log("streams res", res);
        this.streamsList = res;
        this.streamsList.forEach(stream => {
          stream.bdrName = this.bdremp.find(emp => emp.id === stream.bdr)?.name || '';
        });
        this.dataSource = new MatTableDataSource(this.streamsList);        
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;

        const currentSearchText = this.gridSearchText();
        if (currentSearchText) {
            this.applyGridFilter(currentSearchText);
        }
      }
    });
  }

  applyGridFilter(filterText: string) {
    console.log("streams grid search fired");
    const filterValue = filterText.trim().toLowerCase();
    this.dataSource.filter = filterValue;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openContextmenu(data: any) {

  }  
  
  openAddEditForm(data: StreamsList, task: string) {
    const genId = this.filterState()?.generator?.toString() || '0';
    data.task = task
    data.generatorId = parseInt(genId);
    const dialogRef = this._dialog.open(AddeditStreamComponent, {
      data: {
        data: data,
        canSave: this.controlPermissions.editStream,
        isWalmart: this.filterState()?.isWalmart === true
      },
      width: '1000px',
      maxWidth: '1050px',
      disableClose: true,
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const marketId = this.filterState()?.market?.toString() || '-1';
        const genId = this.filterState()?.generator?.toString() || '0';
        this.getStreams(marketId, genId);
        this.notificationService.show(`Data saved successfully`, 'Success');
      }
    });
  }
  
  deleteStream(id: number, name: string){
    const dialogData: ConfirmationDialogData = {
      title: 'Confirm Deletion',
      message: `Are you sure you want to delete Stream ${name}?`,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'warn'
    };

    this._dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      panelClass: 'delete-confirmation-dialog',
      data: dialogData,
      disableClose: true
    }).afterClosed().subscribe(result => {
      if (result) {
        if (id !== null && id !== undefined) {
          const genId = this.filterState()?.generator?.toString() || '0';
          this.fsService.deleteStream(id, parseInt(genId)).subscribe({
            next: () => {
              this.getStreams(this.filterState()?.market?.toString() || '-1', genId);
              this.notificationService.show(`Stream deleted successfully`, 'Success');
            }
          });
        }
      }
    });
  }

  showPickUpLocations(id: number, data: StreamsList){
    const genId = this.filterState()?.generator?.toString() || '0';
    const dialogRef = this._dialog.open(AddeditPickuplocationComponent, {
      data: {
        genid: parseInt(genId),
        streamid: id,
        inputData: data
      },
      width: '650px',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getStreams(this.filterState()?.market?.toString() || '-1', genId);
      }
    });
  }

  showRecurringLoads(id: number){
    const genId = this.filterState()?.generator?.toString() || '0';
    const dialogRef = this._dialog.open(RecurringLoadsComponent, {
      data: {
        genid: parseInt(genId),
        streamid: id
      },
      disableClose: true,
      width: '1000px',
      maxWidth: '1050px',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

  showSamplingFrequencies(id: number){
    const genId = this.filterState()?.generator?.toString() || '0';
    const dialogRef = this._dialog.open(SamplingFrequenciesComponent, {
      data: {
        genid: parseInt(genId),
        streamid: id
      },
      disableClose: true,
      width: '1000px',
      maxWidth: '1050px',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

  openAttachDocuments(id: number, name: string): void {
    const dialogRef = this._dialog.open(AttachDocumentsComponent, {
      panelClass: 'attachDocumentsDialog',
      disableClose: true,
       width: '500px',
      maxWidth: '500px',
      data: {
        loadScheduleId: id,
        screenTypeId: '1',
        name: name
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

  openViewDocsDialog(loadScheduleId: number, name: string): void {
    this._dialog.open(ViewDocumentsComponent, {
      //panelClass: 'viewDocsDialog',
      disableClose: true,
      data: {
        loadScheduleId: loadScheduleId,
        screenTypeId: '1',
        canShowGridActions: this.controlPermissions.showDocumentDeleteButton,
        name: name
      }
    });
  }

  loadMenuDataAndOpen(row: StreamsList, trigger: MatMenuTrigger): void {
    this.fsService.getLoadslipByStream(row.streamId).subscribe({
      next: (data: boolean) => {
        row.loadSlip = data;
        trigger.openMenu();
      }
    });
  }

  getIconBgClass(row: any): any {
    return { iconBGColor: row.loadSlip == true };
  }
}
